export default class DdhpError{
    constructor(code, message, data){
        this.code = code;
        this.message = message;
        this.data = data || {};
    }

    static DuplicatePlayer(playerContract, times) {
        return new DdhpError('DupPlayer',
            `Player ${playerContract.player.firstName} ${playerContract.player.lastName} chosen ${times} times`,
            {playerContract: playerContract, times: times});
    }

    static SubmitFailed(response){
        return new DdhpError('SubmitFailed',
            `Failed to communicate with server. Status ${response.status}`);
    }

    static RequestFailed(response){
        return new DdhpError('RequestFailed',
            `Failed to communicate with server. Status ${response.status}`);
    }
}